import { render, staticRenderFns } from "./IndicationStatic.vue?vue&type=template&id=7a9f5920&scoped=true"
import script from "./IndicationStatic.vue?vue&type=script&lang=js"
export * from "./IndicationStatic.vue?vue&type=script&lang=js"
import style0 from "./IndicationStatic.vue?vue&type=style&index=0&id=7a9f5920&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9f5920",
  null
  
)

export default component.exports